var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Timeline as ExperimentalTimeline, TimelineContent as ExperimentalTimelineContent, TimelineDot as ExperimentalTimelineDot, TimelineHeading as ExperimentalTimelineHeading, TimelineItem as ExperimentalTimelineItem, TimelineLine as ExperimentalTimelineLine, } from "@/components/ui/ExperimentalTimeline";
export function VerticalTimelinePid(_a) {
    var data = _a.data;
    var initialSteps = [
        {
            key: "dataProcesso",
            name: "Abertura do Processo",
            description: "",
            type: "process",
        },
        {
            key: "dataPagamento",
            name: "Pagamento",
            description: "",
            type: "process",
        },
        {
            key: "dataEmissaoPid",
            name: "PID emitida",
            description: "Data que a gráfica emitiu a PID",
            type: "process",
        },
    ];
    var formatDate = function (data, type) {
        if (data == null)
            return "---";
        if (typeof data === "number") {
            data = data.toString();
        }
        var ano = data.slice(0, 4);
        var mes = data.slice(4, 6);
        var dia = data.slice(6, 8);
        return "".concat(dia, "/").concat(mes, "/").concat(ano);
    };
    var isAttrNull = function (attrName, attrType) {
        return findAttributeDateValue(attrName, attrType) == null;
    };
    var findAttributeDateValue = function (attrName, attrType) {
        return data[attrName];
    };
    var isLastStep = function (idx) { return initialSteps.length === idx + 1; };
    function TimelineDotDefault() {
        return _jsx(ExperimentalTimelineDot, {});
    }
    function TimelineDotSuccess() {
        return _jsx(ExperimentalTimelineDot, { status: "done" });
    }
    function TimelineDotError() {
        return _jsx(ExperimentalTimelineDot, { status: "error" });
    }
    var StatusTimelineDot = function (_a) {
        var item = _a.item;
        if (isAttrNull(item.key, item.type)) {
            return _jsx(TimelineDotDefault, {});
        }
        else {
            switch (item.type) {
                case "process":
                    return _jsx(TimelineDotSuccess, {});
                default:
                    return _jsx(_Fragment, {});
            }
        }
    };
    var ResultContent = function (_a) {
        var item = _a.item;
        switch (item.key) {
            case "dataEmissaoPid":
                if (!isAttrNull(item.key, item.type)) {
                    return (_jsxs("div", __assign({ className: "flex flex-col gap-1" }, { children: [_jsxs("span", __assign({ className: "text-sm font-normal" }, { children: ["emitido em:", " ", formatDate(findAttributeDateValue(item.key, item.type), item.type)] })), _jsx("span", __assign({ className: "text-sm font-medium" }, { children: "Por favor, dirija-se \u00E0 sede do Detran em Teresina para retirar sua certid\u00E3o." })), " ", _jsx("span", __assign({ className: "text-sm" }, { children: "Endere\u00E7o: Av. Industrial Gil Martins, 2000 - Reden\u00E7\u00E3o, Teresina - PI, 64017-870" })), _jsx("a", __assign({ href: "https://g.co/kgs/c9D1zj8", target: "_blank", className: "no-underline text-[#1e65c1]", rel: "noreferrer" }, { children: "Ver no Google" }))] })));
                }
                return _jsx(_Fragment, {});
            default:
                return !isAttrNull(item.key, item.type) ? (_jsxs("span", __assign({ className: "text-sm" }, { children: ["realizado em:", " ", formatDate(findAttributeDateValue(item.key, item.type), item.type)] }))) : (_jsx(_Fragment, {}));
        }
    };
    return (_jsx(ExperimentalTimeline, { children: initialSteps.map(function (item, index) { return (_jsxs(ExperimentalTimelineItem, { children: [_jsx(StatusTimelineDot, { item: item }), _jsx(ExperimentalTimelineHeading, { children: item.name }), _jsx(ExperimentalTimelineContent, { children: _jsx(ResultContent, { item: item }) }), !isLastStep(index) && _jsx(ExperimentalTimelineLine, {})] }, index)); }) }));
}
